import AbstractObserver from './abstract';

export default class HeaderWithoutBehaviorObserver extends AbstractObserver {
  constructor(element) {
    super(element);
  }

  init() {
    return this;
  }

  check() {
    return this;
  }

  destroy() {
    return this;
  }

  changeState() {
    return this;
  }

  toDefaultState() {
    return this;
  }
}
